import * as yup from 'yup'
import { decimal, integer, range, uid } from '../../../utils/validation'

export const getValidationLabel = (field) => {
  const result = field.replace(/([A-Z])/g, ' $1')
  return result.charAt(0).toUpperCase() + result.slice(1)
}

yup.addMethod(yup.mixed, 'decimal', decimal)
yup.addMethod(yup.mixed, 'integer', integer)
yup.addMethod(yup.mixed, 'range', range)
yup.addMethod(yup.string, 'uid', uid)

export const InputSchema = yup.object().shape({
  jobSettings: yup.object().shape({
    jobID: yup.string().uid('JobID'),
    quantity: yup
      .mixed()
      // .transform((value) => value?.toString().replace(/,/g, ''))
      .integer('Quantity')
      .range(1, 9999),
  }),
  header: yup.object().shape({
    memberID: yup.string().uid('MemberID'),
  }),
  joist: yup.object().shape({
    memberID: yup.string().uid('MemberID'),
    load: yup.mixed().integer('Download').range(0, 64000),
    uplift: yup.mixed().integer('Uplift').range(0, 64000),
  }),
  girder: yup.object().shape({
    memberID: yup.string().uid('MemberID'),
    kingHeight: yup.mixed().decimal('Total Height').range(0, 1000),
    kingWidth: yup.mixed().decimal('Vertical Width').range(0, 99999),
  }),
  truss: yup.object().shape({
    memberID: yup.string().uid('MemberID'),
    depth: yup.mixed().decimal('Heel Height').range(0, 99999),
    load: yup.mixed().integer('Download').range(0, 64000),
    uplift: yup.mixed().integer('Uplift').range(0, 64000),
  }),
  jack: yup.object().shape({
    memberID: yup.string().uid('MemberID'),
    depth: yup.mixed().decimal('Heel Height').range(0, 99999),
    load: yup.mixed().integer('Download').range(0, 64000),
    uplift: yup.mixed().integer('Uplift').range(0, 64000),
    slopeAngle: yup.mixed().decimal('Slope Angle').range(-49, 49),
  }),
  leftHip: yup.object().shape({
    memberID: yup.string().uid('MemberID'),
    depth: yup.mixed().decimal('Heel Height').range(0, 99999),
    load: yup.mixed().integer('Download').range(0, 64000),
    uplift: yup.mixed().integer('Uplift').range(0, 64000),
    skewAngle: yup.mixed().decimal('Skew Angle').range(0, 85),
    slopeAngle: yup.mixed().decimal('Slope Angle').range(-49, 49),
  }),
  rightHip: yup.object().shape({
    memberID: yup.string().uid('MemberID'),
    depth: yup.mixed().decimal('Heel Height').range(0, 99999),
    load: yup.mixed().integer('Download').range(0, 64000),
    uplift: yup.mixed().integer('Uplift').range(0, 64000),
    skewAngle: yup.mixed().decimal('Skew Angle').range(0, 85),
    slopeAngle: yup.mixed().decimal('Slope Angle').range(-49, 49),
  }),
  hanger: yup.object().shape({
    skewAngle: yup.mixed().decimal('Skew Angle').range(-85, 85),
    slopeAngle: yup.mixed().decimal('Slope Angle').range(-49, 49),
    topFlangeOpenClosedAngle: yup.mixed().decimal('TopFlange Open/Close Angle').range(-30, 30),
    topFlangeSlopedDownAngle: yup.mixed().decimal('TopFlange Sloped Angle').range(-35, 35),
  }),
})

export const DuplicateJobSchema = yup.object().shape({
  jobID: yup.string().uid('JobID'),
})
